import { useNavigate } from "react-router-dom";

/**
 * The two tabs of the Pending Invoices page (sidebar item under W Orders,
 * user 2026-10-29): the W Orders list of invoice-pending orders, and the Job
 * Board's per-product-type view of the same orders.
 */
const TABS = [
  { value: "w-orders", label: "W Orders", to: "/work-orders/invoice-ready?page=1&limit=10" },
  { value: "job-board", label: "Job Board", to: "/pending-invoices/job-board" },
];

export default function PendingInvoicesTabs({ active }) {
  const navigate = useNavigate();
  return (
    <div className="d-flex align-items-center gap-3">
      <h4 className="my-1 me-2">Invoices</h4>
      <ul className="nav nav-tabs nav-bordered border-0 d-flex">
        {TABS.map((t) => (
          <li key={t.value} className="nav-item" onClick={() => active !== t.value && navigate(t.to)}>
            <button
              className={
                // Same box for both states, so the tabs do not shift on switch.
                active === t.value ? "btn btn-primary active bg-primary text-white" : "btn text-primary"
              }
            >
              {t.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
